const firebase = require("firebase");
require("firebase/firestore");

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBYZ10Hghd9LV0W2BOwOYF3clwsK0YWpII",
  authDomain: "webline-ui.firebaseapp.com",
  databaseURL: "https://webline-ui.firebaseio.com",
  projectId: "webline-ui",
  storageBucket: "webline-ui.appspot.com",
  messagingSenderId: "695253674450",
  appId: "1:695253674450:web:150c7ae7b3459de2cac00b",
  measurementId: "G-V3QJNXY1EE"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
export default firebaseApp.firestore();
